/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import CompiledOption, { optionCSS as compiledOptionCSS } from '../compiled/components/option';
import EmotionOption, { optionCSS as emotionOptionCSS } from '../emotion/components/option';
export var optionCSS = function optionCSS(props) {
  return fg('compiled-react-select') ? compiledOptionCSS() : emotionOptionCSS(props);
};
var Option = function Option(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(CompiledOption, props) : /*#__PURE__*/React.createElement(EmotionOption, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Option;